export default __webpack_public_path__ + "static/media/aries.f97e38f4.png";